import { Field } from "formik";
import React from "react";

const FormRadioCheckboxField = (props) => {
  const { label,fieldId, fieldName, type, value, handleChange } = props;
  return (
    <>
      <Field
        className="form-check-input"
        type={type}
        name={fieldName}
        id={fieldId}
        value={value}
        onChange={handleChange}
      />
      <label className="form-check-label" htmlFor={fieldId}>
        {label}
      </label>
    </>
  );
};

export default FormRadioCheckboxField;
